// GameConfig.js
export const GAME_CONFIG = {
    // --- GLOBAL OYUNCU AYARLARI ---
    PLAYER_SPEED: 8.0,
    PLAYER_RADIUS: 0.7,
    MAX_HP: 2, 
    
    // --- FLASH & ZHONYA ---
    FLASH_DISTANCE: 5,
    FLASH_COOLDOWN: 10000,
    ZHONYA_DURATION: 2500,
    ZHONYA_COOLDOWN: 30000,

    // ESKİ SABİTLER (Player.js Uyumu İçin Zorunlu)
    W_DASH_SPEED: 35,
    W_DASH_DISTANCE: 10,
    ZED_W_RANGE: 9,
    ZED_SHADOW_SPEED: 25,
    YASUO_WALL_SPEED: 10,
    YASUO_WALL_TRAVEL_DIST: 4,

    // --- YENİ ŞAMPİYON YAPISI ---
    CHAMPIONS: {
        leblanc: {
            W_COOLDOWN: 6000,
            W_DURATION: 4000,
            DASH_SPEED: 35,
            DASH_DIST: 10
        },
        zed: {
            W_COOLDOWN: 6000,
            W_DURATION: 4000,
            W_RANGE: 9,
            SHADOW_SPEED: 25
        },
        yasuo: {
            W_COOLDOWN: 10000,
            W_DURATION: 3500,
            WALL_WIDTH: 6,
            WALL_DIST: 4,
            WALL_SPEED: 10
        }
    },

    // --- DÜŞMAN & PROJEKTİL ---
    PROJECTILE_RADIUS: 0.2,
    PROJECTILE_SPEED: 28,
    MAP_SIZE: 500,
    
    // --- BOSS ---
    BOSS_TRIGGER_SCORE: 40,
    JHIN_BULLET_SPEED: 55,     
    JHIN_SHOT_DELAY: 800,       
    JHIN_PREPARE_TIME: 1500,    
    JHIN_TOTAL_SHOTS: 4,
    JHIN_ULT_RANGE: 125,
    KARTHUS_CHANNEL_TIME: 3000,
    
    // SKILLS
    XERATH_RADIUS: 3.5,
    XERATH_DELAY: 800,
    XERATH_DAMAGE_DURATION: 200,
    LUX_WIDTH: 2.5,
    LUX_DELAY: 1000,
    LUX_DURATION: 500,

    // --- BUFF & ITEM ---
    GHOST_DURATION: 4000,      
    GHOST_SPEED_MULT: 1.5,     
    
    // BURADAN AYARLAYABİLİRSİN:
    ITEM_DESPAWN_TIME: 5000,   // Itemler 5 saniye sonra yok olur
    
    SPAWN_RATES: {
        HP: 25.0,      
        BANSHEE: 30.0, 
        GHOST: 22.0    
    }
};

export function randomRange(min, max) {
    return Math.random() * (max - min) + min;
}